
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/unsupported-device",
      function () {
        return require("private-next-pages/support/unsupported-device/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/unsupported-device"])
      });
    }
  